import script from "./SolutionView.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionView.vue?vue&type=script&setup=true&lang=js"

import "./SolutionView.vue?vue&type=style&index=0&id=16abe850&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16abe850"]])

export default __exports__